module.exports = __webpack_public_path__ + "static/img/icon-week.70ca2fd3.png";